import type { AlCategory, AlCategoryMeta, AlStatus, AlStatusMeta } from './types';

export const GROWTH_AUTOPILOT_LOG_META = {
  eyebrow: 'Google Ads & SEO · Activity',
  titleLead: 'Autopilot',
  titleAccent: 'log',
  description:
    'Every action ELVA has taken on your behalf. Switch between a plain-language timeline grouped by day, or the full audit trail with timestamps and parameters. The log is read-only — actions can be undone from their respective module pages.',
} as const;

export const AL_CATEGORY_ORDER: readonly (AlCategory | 'all')[] = [
  'all',
  'ads',
  'landing',
  'seo',
  'gbp',
  'intel',
  'technical',
  'call',
] as const;

export const AL_CATEGORY_META: Record<AlCategory, AlCategoryMeta> = {
  ads: { label: 'Ads', tone: 'info' },
  landing: { label: 'Landing Pages', tone: 'lav' },
  seo: { label: 'SEO', tone: 'success' },
  gbp: { label: 'GBP', tone: 'gold' },
  intel: { label: 'Intelligence', tone: 'neutral' },
  technical: { label: 'Technical', tone: 'neutral' },
  call: { label: 'Calls', tone: 'terra' },
};

export const AL_STATUS_META: Record<AlStatus, AlStatusMeta> = {
  success: { label: 'Success', tone: 'success' },
  retrying: { label: 'Retrying', tone: 'gold' },
  failed: { label: 'Failed', tone: 'terra' },
  pending: { label: 'Pending', tone: 'info' },
};
